import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrl: './image.component.css',
})
export class ImageComponent {
  @Input() Image!: string;
  @Input() ImageTitle = '';
  @Input() Loading = '0';
  @Input() ImageAltName = '';
}
